import { useNavigate } from "react-router-dom";
import logger from "../utils/logger";
import Box from "@/components/StyledHtmlElements/Box";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import StyledButton from "@/components/StyledHtmlElements/Button";

const ContactUs = () => {
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    logger.log("Not implemented yet.");
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex justify-center items-center h-svh bg-gray-100">
      <Box className="min-w-[300px] w-[20%] px-6 py-3">
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <h2 className="text-lg md:text-2xl font-bold mb-6 text-center">Contact Us</h2>
          <div>
            <label htmlFor="username" className="text-xs md:text-lg" />
            <Input id="username" type="text" placeholder="Name" />
          </div>
          <div>
            <label htmlFor="email" className="text-xs md:text-lg" />
            <Input id="email" type="email" placeholder="Email" />
          </div>
          <div>
            <label htmlFor="email-message" className="text-xs md:text-lg" />

            <Textarea id="email-message" placeholder="Ihre Nachricht an uns" />
          </div>

          <div className="flex justify-between mt-4">
            <StyledButton onClick={handleBack}>Back</StyledButton>
            <StyledButton type="submit">Submit</StyledButton>
          </div>
        </form>
      </Box>
    </div>
  );
};

export default ContactUs;
